import React, { useState } from "react";
import "./panel.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import { CREATE_BEZIER_TRANSITION } from "../utils";
import {
  getTempStateLocalStorage,
  setTempStateLocalStorage,
} from "../local-store";
import { isNil } from "lodash";

function Panel({
  title,
  initialOpen = false,
  isUpdated,
  id,
  children,
  className,
}) {
  const [opened, setOpened] = useState(
    id && !isNil(getTempStateLocalStorage(id))
      ? getTempStateLocalStorage(id)
      : initialOpen ?? 0,
  );
  const classes = classnames(
    `grigora-panel ${opened ? "opened" : " "}`,
    className,
  );
  return (
    <div className={classes}>
      <div
        className="grigora-panel__title cursor-pointer text-grigora-base font-semibold text-black hover:bg-gray-100 duration-200 flex gap-2 border-b border-gray-200 justify-between px-4 py-2  bg-editor-light-main"
        onClick={(e) => {
          if (id) {
            setTempStateLocalStorage(id, !opened);
          }
          setOpened((prevOpened) => !prevOpened);
        }}
      >
        <div className="align-middle flex items-center">
          <FontAwesomeIcon
            className="grigora-panel__uparrow duration-200 w-[6px] h-auto"
            icon={faCaretRight}
          />
        </div>
        <div className={`grigora-panel__title-text flex-1 select-none`}>
          {title}
        </div>
        {isUpdated ? (
          <div className="align-middle flex items-center">
            <div className="w-[6px] h-[6px] rounded-full bg-blue-500"></div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <AnimatePresence initial={false}>
        {opened && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto", overflow: "unset" },
              collapsed: {
                opacity: 0,
                height: 0,
                paddingBottom: 0,
                overflow: "hidden",
              },
            }}
            transition={CREATE_BEZIER_TRANSITION()}
            className="grigora-panel__content border-b border-gray-200"
          >
            <div className="px-4 py-2">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Panel;
